/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Snapshot_History_Close_Aria_LabelInputs */

const en_snapshot_history_close_aria_label = /** @type {(inputs: Snapshot_History_Close_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Close modal`)
};

const fr_snapshot_history_close_aria_label = /** @type {(inputs: Snapshot_History_Close_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fermer la boite de dialogue`)
};

const de_snapshot_history_close_aria_label = /** @type {(inputs: Snapshot_History_Close_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modal schließen`)
};

const it_snapshot_history_close_aria_label = /** @type {(inputs: Snapshot_History_Close_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chiudi modale`)
};

const ru_snapshot_history_close_aria_label = /** @type {(inputs: Snapshot_History_Close_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Закрыть модальное окно`)
};

const es_snapshot_history_close_aria_label = /** @type {(inputs: Snapshot_History_Close_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cerrar modal`)
};

const zh_cn2_snapshot_history_close_aria_label = /** @type {(inputs: Snapshot_History_Close_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`关闭模态框`)
};

const ja_snapshot_history_close_aria_label = /** @type {(inputs: Snapshot_History_Close_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`モーダルを閉じる`)
};

const hi_snapshot_history_close_aria_label = /** @type {(inputs: Snapshot_History_Close_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मॉडल बंद करें`)
};

const pt_pt2_snapshot_history_close_aria_label = /** @type {(inputs: Snapshot_History_Close_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fechar modal`)
};

/**
* | output |
* | --- |
* | "Close modal" |
*
* @param {Snapshot_History_Close_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const snapshot_history_close_aria_label = /** @type {((inputs?: Snapshot_History_Close_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Snapshot_History_Close_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_snapshot_history_close_aria_label(inputs)
	if (locale === "de") return de_snapshot_history_close_aria_label(inputs)
	if (locale === "it") return it_snapshot_history_close_aria_label(inputs)
	if (locale === "ru") return ru_snapshot_history_close_aria_label(inputs)
	if (locale === "es") return es_snapshot_history_close_aria_label(inputs)
	if (locale === "zh-CN") return zh_cn2_snapshot_history_close_aria_label(inputs)
	if (locale === "ja") return ja_snapshot_history_close_aria_label(inputs)
	if (locale === "hi") return hi_snapshot_history_close_aria_label(inputs)
	if (locale === "pt-PT") return pt_pt2_snapshot_history_close_aria_label(inputs)
	return en_snapshot_history_close_aria_label(inputs)
});